import { memo, useState } from 'react';

import { Link } from 'react-router-dom';

import { useSponsorsQuery } from '@hooks';

import * as S from './styles';

const BroadcastSponsors = () => {
  const { data: sponsorsData, isLoading } = useSponsorsQuery();
  const [paused, setPaused] = useState(false);

  const sponsors = sponsorsData?.sponsors ?? [];

  if (isLoading || sponsors.length === 0) {
    return null;
  }

  // Duplicate list to create seamless infinite scroll
  const duplicated = [...sponsors, ...sponsors];
  const duration = sponsors.length * 3;

  return (
    <S.Wrapper>
      <S.Container
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <S.Track $duration={duration} $paused={paused}>
          {duplicated.map((sponsor, index) => (
            <S.SponsorItem
              as={Link}
              to={`/sponsors/${sponsor.id}`}
              // eslint-disable-next-line react/no-array-index-key
              key={`sponsor-${sponsor.id}-${index}`}
              title={sponsor.name}
            >
              <img src={sponsor.logo} alt={sponsor.name} loading="lazy" />
            </S.SponsorItem>
          ))}
        </S.Track>
      </S.Container>
    </S.Wrapper>
  );
};

export default memo(BroadcastSponsors);
